import { render, staticRenderFns } from "./infos.vue?vue&type=template&id=3466b112&"
import script from "./infos.vue?vue&type=script&lang=js&"
export * from "./infos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports